import { formatters } from '@utils/formattersV2';
import { SplineChartWithHeader } from '../../../../../../components/Summary/SplineChartWithHeader';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { reportsToSeriesData } from '../../../../utils';

type UsersSplineChartProps = {
  reports: Lci3Report[];
};

export const UsersSplineChart = (props: UsersSplineChartProps) => {
  const usersSplineData = reportsToSeriesData({
    reports: props.reports,
    type: 'visit',
    field: 'uniqueUsers',
  });

  return (
    <SplineChartWithHeader
      title="Unique Users"
      data={usersSplineData}
      color={unifiedPlatformColorPalette.chartLightGreen}
      formatter={value => formatters.users(value, { full: true })}
      yAxisLabelFormatter={formatters.number}
      differenceType="standard"
      data-testid="unique-users-chart"
    />
  );
};
